/** @jsxImportSource @emotion/react */
import { useSelector } from "react-redux"
import { IAppState } from "../core/redux/IAppState"
import { MediumText, UNSELECTABLE_TEXT } from "../styles/styles";
import { WHITE } from "../styles/colors";
import FloatingContent from "../layout/FloatingContent";
import { useThrottleState } from "../language/hooks/useThrottleState";
import { useCallback } from "react";
import { useRefCallback } from "../language/hooks/useRefCallback";
import { getResource } from "../language/resources/getResource";
import { PreferencesModal } from "./PreferencesModal";
import solidArrow from '../assets/icons/downArrowSolid.svg';
import { css } from "@emotion/react";

const floatingMenuArrow = css`
  width: 19px; /* Odd dimensions size image to the height of a lower-case letter @ 2rem */
  height: 9.5px;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 5px;
  ${UNSELECTABLE_TEXT};
`;

const localeName = css`  
  color: ${WHITE}; 
  opacity: .9;
  ${MediumText};
`;

export const PreferencesMenu = () => {

    const resources = useSelector((state: IAppState) => state.locale);
    const currentDateFormat = useSelector((state: IAppState) => state.defaultDateFormat);
    const [isOpen, setIsOpen] = useThrottleState(false);

    const closeMenu = useCallback(() => setIsOpen(false), [setIsOpen]);

    const onClickToToggleMenu = useRefCallback(
        () => {    
          setIsOpen(!isOpen);
        },
      );

    const currentLanguage = resources ? resources["LOCALE_NAME"] : "";
    return (
        <div css={css`margin-top: 20px; flex-grow: 1;`}>
          <span css={localeName} onClick={onClickToToggleMenu}>
            {resources && currentLanguage}<br/>{currentDateFormat.replaceAll('-','/').toLowerCase()}
          </span>
          <FloatingContent
            showFloatingContent={isOpen}
            xPosition={'center'}
            yPosition={'below'}
            onClickOutside={closeMenu}
            floatingContent={
                <PreferencesModal 
                    resources={resources} 
                    currentDateFormat={currentDateFormat}
                    setIsOpen={setIsOpen}/>
            }
            zIndex={200}
            rootCss={css`
                height: 100%;
                display: inline-block;
            `}
            >
            <div
                onClick={onClickToToggleMenu}
                title={isOpen ? getResource(resources, 'FLOATING_MENU_CLOSE') : getResource(resources, 'FLOATING_MENU_OPEN')}
                css={css`
                cursor: ${'pointer'};

                &:hover {
                    ${'opacity: .5'};
                }
                `}
            >
                <img alt='arrow'
                src={solidArrow}
                css={floatingMenuArrow}
                onClick={onClickToToggleMenu}/>
            </div>
            </FloatingContent>
        </div>

    )
}